import { render, staticRenderFns } from "./PublicTransportTicket.vue?vue&type=template&id=48986682&scoped=true&lang=pug&"
import script from "./PublicTransportTicket.vue?vue&type=script&lang=js&"
export * from "./PublicTransportTicket.vue?vue&type=script&lang=js&"
import style0 from "./PublicTransportTicket.vue?vue&type=style&index=0&id=48986682&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48986682",
  null
  
)

export default component.exports